import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import VueElementLoading from 'vue-element-loading';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import Pagination from './../../shared/pagination'
Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'rtoextraexcessproductreport',
  components: {
    Pagination,
    DatePicker,
    download,
    JsonExcel,
    Loader,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoadingforxls: false,
      show: false,
      download: true,
      dataFilter2: '',
      reportname: '',
      csvFieldsForXls: {},
      listReportDataforxls: [],
      totalRows: 0,
      listRtoReportData: [],
      listRtoReportDatacsv: [],
      listRtoReportFinalData: [],
      csvFields: [],
      pageno: 0,
      pageCount: 0,
      producttype: '',
      fromdate: '',
      todate: '',
      isLoading: false,
      formattedDate: '',
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      ClientErr: '',
      ReporttypeErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      Reporttype: '',
      user_type: '',
      warehouseid: '',
      warehouse: '',
      WarehouseErr: '',
      clientid: '',
      client: '',
      rtoid: '',
      reporttype: '',
      currentPage: 1,
      pageLimit: 10,
    }
  },
  computed: {

  },
  filters: {
    moment: function (date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY hh:mm:ss');
    }
  },
  mounted() {
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdbyEmail = userdetail.email;
    this.reportname = this.$t('editedjson.rvprtoextraexcessreport')
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    //this.getStockReportData();
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError') + "Unauthorised user, Please contact your system admin");
        break
    }

  },
  methods: {
    Choosetype() {
      this.show = true;
      this.download = false;
      this.getRtoReportDataForXls(3)
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    // getClientList() {
    //   this.listClientData = '';
    //   var userToken = window.localStorage.getItem('userToken');
    //   var myStr = userToken.replace(/"/g, '');

    //   this.input = ({
    //     warehouseid: this.warehouseid,
    //   });

    //   axios({
    //     method: 'POST',
    //     'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //     'data': this.input,
    //     headers: {
    //       'Authorization': 'Bearer ' + myStr,
    //     }
    //   })
    //     .then(result => {
    //       this.listClientData = result.data.data;
    //     }, error => {
    //       console.error(error);
    //     });
    // },
    // getWarehouseList() {
    //   var userToken = window.localStorage.getItem('userToken')
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageno = 0;
    //   this.input = ({
    //     clientid: this.clientid,
    //   });

    //   axios({
    //     method: 'POST',
    //     'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //     'data': this.input,
    //     headers: {
    //       'Authorization': 'Bearer ' + myStr
    //     }
    //   })
    //     .then(result => {
    //       // console.log(result.data.data);
    //       this.listWarehouseData = result.data.data;
    //     }, error => {
    //       console.error(error)
    //     })

    //   /////////

    // },
    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid);
    //       // this.getStockReportData();
    //     }
    //   }
    //   this.listRtoReportData = [];
    //   this.pageno = this.pageCount = 0;
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.pageCount = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       // console.log(this.warehouse);
    //       // this.getStockReportData();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getRtoReportDataSearch() {
      this.pageno = 0;
      this.pageCount = 0;
      this.searchFlag = true;
      this.getRtoReportData(2);
    },
    change1() {

      this.currentPage = 1
      console.log(this.currentPage + "sagar")
    },


    //to get client list
    getRtoReportData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      var dataFilter = {};
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.currentPage = 1
      }
      // this.ClientErr = '';
      if (localStorage.getItem("selectedClient") == 'undefined') {
        this.WarehouseErr = this.$t('common.clientError');
        this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.pageCount = 0;
        this.listRtoReportData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.pageCount = 0;
        this.listRtoReportData = [];
        return false;
      }
      if (this.reporttype == '') {
        this.ReporttypeErr = this.$t('rejectlistrto.reportTypeError');
        this.pageNo = this.pageCount = 0;
        this.listRtoReportData = [];
        return false;
      }

      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }


      this.isLoading = true;
      if (csvCheck == 2)
        this.pageno = 0;

      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        fromdate: fr_date,
        todate: to_date,
        producttype: this.producttype,
        clientid: this.client,
        warehouseid: localStorage.getItem("selectedWarehouse"),
        rtoid: this.rtoid,

        reporttype: this.reporttype,
      })
      if (csvCheck == 1) {
        this.input.offset = 0
        this.input.limit = 0

      }

      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          k = k.charAt(0).toUpperCase() + k.slice(1)
          dataFilter[k] = v;
        }
      })
      if (this.reporttype == "RTO") {
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'rtoextraexcessproductreport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })

          .then(result => {
            this.Reporttype = result.data.reporttype
            if (csvCheck == 1) {
              this.show = true;
              this.download = false;
              this.listRtoReportDataCsv = [];
              this.csvFields = {
                'rtoid': this.$t('shipment.rtoId'),
                'productname': this.$t('common.productName'),
                'productid': this.$t('common.productId'),
                'producttype': this.$t('common.productType'),
                'qty': this.$t('common.qty'),
                'createddatetime': this.$t('consolidation.createdDatetime'),
              };
              var dateFilter = [];
              var skipFilter = [];
              this.listRtoReportDataCsv = result.data.data;


              csvHelper.data.jsonToCSV(this.$t('editedjson.rtoReport'), this.listRtoReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

              // this.jsonToCSV('StockReport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
            } else {
              this.listRtoReportData = result.data.data
              if (result.data.errorCode == -1) {
                this.resultCount = 0
              } else {
                this.totalRows = result.data.count
                this.resultCount = result.data.count
                if (this.totalRows < this.pageLimit) {
                  this.pageCount = 1
                } else {
                  this.pageCount = Math.ceil(this.totalRows / this.pageLimit)
                }
              }
            }

            this.isLoading = false;
          }, error => {
            console.error(error);
          })
      } else {

        this.input = ({
          offset: (this.currentPage - 1) * 10,
          limit: this.pageLimit,
          fromdate: fr_date,
          todate: to_date,
          producttype: this.producttype,
          clientid: this.client,
          warehouseid: localStorage.getItem("selectedWarehouse"),
          srid: this.rtoid,

          reporttype: this.reporttype,
        })
        if (csvCheck == 1) {
          this.input.offset = 0
          this.input.limit = 0

        }
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'srextraexcessproductreport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })

          .then(result => {
            this.Reporttype = result.data.reporttype
            if (csvCheck == 1) {
              this.show = true;
              this.download = false;
              this.listRtoReportDataCsv = [];
              this.csvFields = {
                'srid': this.$t('rejectlistrto.rvpID'),
                'productname': this.$t('common.productName'),
                'productid': this.$t('common.productId'),
                'producttype': this.$t('common.productType'),
                'qty': this.$t('common.qty'),
                'createddatetime': this.$t('consolidation.createdDatetime'),
              };
              var dateFilter = [];
              var skipFilter = [];
              this.listRtoReportDataCsv = result.data.data;



              csvHelper.data.jsonToCSV(this.$t('editedjson.rvpReport'), this.listRtoReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

              // this.jsonToCSV('StockReport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
            } else {
              this.listRtoReportData = result.data.data
              if (result.data.errorCode == -1) {
                this.resultCount = 0
              } else {
                this.totalRows = result.data.count
                this.resultCount = result.data.count
                if (this.totalRows < this.pageLimit) {
                  this.pageCount = 1
                } else {
                  this.pageCount = Math.ceil(this.totalRows / this.pageLimit)
                  console.log("here" + this.pageCount)
                }
              }
            }

            this.isLoading = false;
          }, error => {
            console.error(error);
          })




      }///
    },
    getRtoReportDataForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      // this.ClientErr = '';
      if (localStorage.getItem("selectedClient") == 'undefined') {
        this.WarehouseErr = this.$t('common.clientError');
        this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.pageCount = 0;
        this.listRtoReportData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.pageCount = 0;
        this.listRtoReportData = [];
        return false;
      }

      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }

      if (csvCheck == 2)
        this.pageno = 0;
      this.input = ({
        offset: 0,
        limit: 0,
        fromdate: fr_date,
        todate: to_date,
        producttype: this.producttype,
        rtoid: this.rtoid,

        clientid: this.client,
        warehouseid: localStorage.getItem("selectedWarehouse"),
        reporttype: this.reporttype,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k.charAt(0).toUpperCase() + k.slice(1) + ':' + v + ', '
          this.dataFilter2 = str.concat(value);

        }
      })

      if (this.Reporttype == "RTO") {
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'rtoextraexcessproductreport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then(result => {
            if (csvCheck == 3) {
              if (result.data.data.length > 0) {
                this.listReportDataforxls = [];
                this.csvFieldsForXls[this.$t('shipment.rtoId')]= 'rtoid';
                this.csvFieldsForXls[this.$t('common.productName')]= 'productname';
                this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
                this.csvFieldsForXls[this.$t('common.productType')]= 'producttype';
                this.csvFieldsForXls[this.$t('common.qty')]= 'qty';
                this.csvFieldsForXls[this.$t('common.createdDate')]= 'createddatetime';
                this.listReportDataforxls = result.data.data;
              }
              else {
                if (result.data.status == true) {
                  this.$alertify.success(this.$t('common.reportSizeError') );
                } else {
                  this.$alertify.error(result.data.msg.message);
                }
              }


            }


          }, error => {
            console.error(error)
          })
      } else {

        this.input = ({
          offset: 0,
          limit: 0,
          fromdate: fr_date,
          todate: to_date,
          producttype: this.producttype,
          srid: this.rtoid,

          clientid: this.client,
          warehouseid: localStorage.getItem("selectedWarehouse"),
          reporttype: this.reporttype,
        })
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'srextraexcessproductreport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
          .then(result => {
            if (csvCheck == 3) {
              if (result.data.data.length > 0) {
                this.listReportDataforxls = [];
                this.csvFieldsForXls[this.$t('rejectlistrto.rvpID')]= 'srid';
                this.csvFieldsForXls[this.$t('common.productName')]= 'productname';
                this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
                this.csvFieldsForXls[this.$t('common.productType')]= 'producttype';
                this.csvFieldsForXls[this.$t('common.qty')]= 'qty';
                this.csvFieldsForXls[this.$t('common.createdDate')]= 'createddatetime';
                this.listReportDataforxls = result.data.data;
              }
              else {
                if (result.data.status == true) {
                  this.$alertify.success(this.$t('common.reportSizeError') );
                } else {
                  this.$alertify.error(result.data.msg.message);
                }
              }


            }


          }, error => {
            console.error(error)
          })


      }
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * this.pageLimit
      this.getRtoReportData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getRtoReportData();
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    //to reset search form
    resetSearchForm() {
      this.reporttype = '',
        this.rtoid = ''
      this.show = false;
      this.download = true;
      this.producttype = '';
      this.fromdate = '';
      this.todate = '';
      this.totalRows = 0;
      this.pageno = this.pageCount = 0;
      this.listRtoReportData = [];
      this.searchFlag = false;
      if (this.user_type == 'warehouse_user')
        this.clientname = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        // this.client = '';
        this.warehouse = '';
      }
      //this.getStockReportData();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/reports/rtoextraexcessproductreport/rtoextraexcessproductreport.component.js